import { getFirestore, doc, getDoc } from 'firebase/firestore';

/**
 * Check if the current user is an admin
 * @param {Object} user - Firebase auth user object
 * @returns {Promise<boolean>} - True if user is admin, false otherwise
 */
export const isUserAdmin = async (user) => {
  if (!user) return false;
  
  try {
    const db = getFirestore();
    const userDoc = await getDoc(doc(db, 'users', user.uid));
    
    return userDoc.exists() && userDoc.data().isAdmin === true;
  } catch (error) {
    console.error('Error checking admin status:', error);
    return false;
  }
};

/**
 * Check if user has access to a resource (either owns it or is admin)
 * @param {Object} user - Firebase auth user object
 * @param {string} resourceUserId - The userId that owns the resource
 * @returns {Promise<boolean>} - True if user has access, false otherwise
 */
export const hasResourceAccess = async (user, resourceUserId) => {
  if (!user) return false;
  
  // Check ownership first (faster)
  if (user.uid === resourceUserId) return true;
  
  // Check admin status if not owner
  return await isUserAdmin(user);
};
